import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import { Trash2Icon } from 'components/shared/Icon/model'

import styles from '../ActionButtons.module.scss'

type DeleteButtonProps = Pick<
  React.ComponentProps<typeof Button>,
  'ariaLabel' | 'className' | 'size' | 'onClick' | 'isDisabled'
>

export const DeleteButton = ({
  ariaLabel,
  className = undefined,
  size = 'medium',
  onClick,
  isDisabled,
}: DeleteButtonProps) => (
  <Button
    className={cx(styles.button, className)}
    icon={Trash2Icon}
    variant="outlined"
    {...{ ariaLabel, size, onClick, isDisabled }}
  />
)
